export const aboutCards = [
  {
    title: 'Market-grade monitoring',
    copy: 'We sweep EDGAR every 10 minutes, normalize entities, and attach tickers so you see material filings before they hit the newswire.'
  },
  {
    title: 'Context-aware AI',
    copy: 'Models are tuned on SEC language - covenant changes, liquidity flags, risk factors - and return plain-English rationales you can defend.'
  },
  {
    title: 'From insight to trade',
    copy: 'REST, webhooks, and email/Slack routes keep your desk in sync. Every signal carries confidence, rationale, and suggested action.'
  }
];

export const features = [
  {
    title: 'Real-time EDGAR watchtower',
    blurb: 'Fresh filings flow into a ranked queue with anomaly flags and ticker-level heatmaps.',
    bullets: ['10-minute crawl cadence', 'Entity resolution for subsidiaries & tickers', 'Novelty scoring to surface what changed']
  },
  {
    title: 'Filing-native AI reads',
    blurb: 'Summaries, risk shifts, and trade theses built for 10-Ks, 10-Qs, 8-Ks, and S-1s.',
    bullets: ['Signals tied to sections & page numbers', 'Confidence + sentiment side-by-side', 'Auditable rationales for compliance']
  },
  {
    title: 'Desk-ready integrations',
    blurb: 'Drop signals into the tools you already use without re-platforming your stack.',
    bullets: ['REST + webhook delivery', 'CSV exports & Slack/Email digests', 'Webhook retries with signed payloads']
  },
  {
    title: 'Risk controls baked in',
    blurb: 'Guardrails to reduce noise and keep capital allocated to what matters.',
    bullets: ['Concentration controls per sector', 'Spam/duplicate suppression', 'Confidence thresholds you set']
  }
];

export const plans = [
  {
    name: 'Starter',
    badge: undefined,
    price: '$0',
    cadence: '/mo',
    note: 'For analysts validating the workflow.',
    features: [
      'Up to 50 filings/month',
      'Email & in-app delivery'
    ],
    recommended: false
  },
  {
    name: 'Pro',
    badge: undefined,
    price: '$15',
    cadence: '/mo',
    note: 'Full coverage for active desks.',
    features: [
      'Unlimited filings & tickers',
      'Full rationale + trade thesis',
      'Priority support'
    ],
    recommended: true
  }
];

export const posts = [
  { title: 'How to convert 10-Ks into tradeable edges', tag: 'Research', time: '7 min read' },
  { title: 'Building a filing heatmap that stays ahead of the feed', tag: 'Engineering', time: '5 min read' },
  { title: 'Playbook: reacting to 8-K surprises within 30 minutes', tag: 'Playbook', time: '6 min read' }
];

export const faqs = [
  {
    q: 'What makes EDGAR Insights different?',
    a: 'We focus solely on SEC filings, pairing a 10-minute crawl schedule with models trained on filing language so you get precise, auditable theses instead of generic summaries.'
  },
  {
    q: 'Can I push signals into my own systems?',
    a: 'Yes. Every plan supports REST delivery; Pro adds signed webhooks, CSV exports, and Slack/Teams routes so you can keep existing workflows intact.'
  },
  {
    q: 'How noisy are the alerts?',
    a: 'You control thresholds, tickers, and sectors. We score novelty and sentiment, suppress duplicates, and show our rationale so you can tune the stream.'
  },
  {
    q: 'Is there a trial?',
    a: 'We do not offer a free trial. You can start on the monthly plan and cancel anytime.'
  },
  {
    q: 'Who is it for?',
    a: 'Event-driven, fundamental, and risk teams who need faster read-through on filings without hiring a fleet of analysts.'
  }
];
